import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define el tipo de estado inicial
export interface CounterState {
  value: number;
}

// Define el tipo de la acción 'incrementByAmount'
interface IncrementByAmountAction {
  payload: number;
}

const initialState: CounterState = {
  value: 0,
};

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action: PayloadAction<number>) => {
      state.value += action.payload;
    },
  },
});

// Exporta las acciones generadas por createSlice
export const { increment, decrement, incrementByAmount } = counterSlice.actions;

// Exporta el reducer generado por createSlice
export default counterSlice.reducer;
